module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-SBT-Feature-b2d3d93704b9e68f8c2cef2ff9275df1.jpg";